export const urls = {
  GET_KUPAC: 'Kupci/vrati_kupca_za_id',
  GET_KONTAKTI_KUPCA: 'KontaktiKupca/vrati_kontakte_kupca_za_id',
  POSALJI_EMAIL: 'SlanjeEmaila/posalji_izvestaj_radnog_naloga',
  POSALJI_EMAIL_TEKST: 'SlanjeEmaila/posalji_izvestaj_radnog_naloga_tekst',
  UNOS_EMAIL_EVIDENCIJE: 'DokRNServisni/DokRNServisniEmailEvidencija_I',
  GET_EMAIL_EVIDENCIJA: 'DokRNServisni/DokRNServisniEmailEvidencija_Vrati',
  GET_RN_ZAGLAVLJE: 'DokRNServisni/vrati_dok_rn_servisni_za_id',
  GET_PUR_ZAGLAVLJE: 'DokRNPustanjeURad/vrati_dok_rn_pustanje_u_rad_za_id',
  GET_SERVISNI_ZAHTEV_ZA_ID:
    'DokServisniZahtevi/vrati_dok_servisni_zahtev_za_id',
  GET_ZAPOSLENI_ZA_RN: 'DokRNServisni/RNS_vrati_zaposlene_na_rn',
  GET_IZVRSENE_USLUGE:
    'DokRNServisniStavkeZaposleni/vrati_stavke_zaposleni_za_dok_rn_servisni',
  GET_TRANSPORT:
    'DokRNServisniStavkeZaposleni/vrati_stavke_transport_za_dok_rn_servisni',
  GET_CENE_RADA_ZAPOSLENOG:
    'DokRNServisniStavkeZaposleni/dok_rn_servisni_vrati_vrste_usluge_stavke_zaposleni',
  GET_CENE_PUTA_ZAPOSLENOG:
    'DokRNServisniStavkeZaposleni/dok_rn_servisni_vrati_vrste_usluge_stavke_transport',
  GET_DELOVI:
    'DokRNServisniStavkeDelovi/vrati_stavke_delovi_za_dok_rn_servisni',
  GET_TROSKOVI:
    'DokRNServisniStavkeTroskovi/vrati_stavke_troskovi_za_dok_rn_servisni',
  GET_OPIS_RADOVA: 'RNSZaposleniOpisRadovaTeren/rn_servisni_opisi_radova',
  GET_STAVKE_PUSTANJA:
    'DokRNPustanjeURadStavke/vrati_stavke_dok_rn_pustanje_u_rad_za_id',
  GET_DNEVNIK:
    'DnevnaEvidencija/vrati_dnevne_evidenciju_za_idDok_radnog_naloga_web',
  GET_BELESKE: 'DnevnikKomisije/vrati_dnevnik_komisije_za_idDok',
};
